import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { MenuItem, ListItemIcon } from '@mui/material';
import CustomMenu from '../../../Components/CustomMenu';

const OptionsMenu = function OptionsMenu({
  anchor = null,
  data = {},
  onClose = () => {},
  onEdit = () => {},
  onDelete = () => {},
  disableDelete = false,
}) {
  const intl = useIntl();

  return (
    <CustomMenu
      open={Boolean(anchor)}
      anchor={anchor}
      close={onClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <div>
        <MenuItem onClick={() => onEdit(data)}>
          <ListItemIcon>
            <EditRoundedIcon />
          </ListItemIcon>
          {intl.messages.EDIT_USER}
        </MenuItem>
        <MenuItem onClick={() => onDelete(data)} disabled={disableDelete}>
          <ListItemIcon>
            <DeleteRoundedIcon />
          </ListItemIcon>
          {intl.messages.DISABLE_USER}
        </MenuItem>
      </div>
    </CustomMenu>
  );
};

OptionsMenu.propTypes = {
  anchor: PropTypes.object,
  data: PropTypes.object,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  disableDelete: PropTypes.bool,
};

export default OptionsMenu;
